import { Fragment } from 'react'
import PropTypes from 'prop-types'

import { formatters } from 'reactUtils/formatters'

import { WelcomeText } from './components/WelcomeText'
import { HeaderElement, Photo, PhotoImage, Welcome, TextWelcome, Ticket, TicketHaveText, TicketValue, TicketText } from './styles'

function Header ({ user, children }) {
  return (
    <Fragment>
      <HeaderElement>
        <Photo>
          <PhotoImage avatar={user.picture}>
            {!user.picture && user.name.substring(0, 1)}
          </PhotoImage>
        </Photo>

        <Welcome>
          <TextWelcome>Bem-vindo, {user.name}!</TextWelcome>
          <WelcomeText />
        </Welcome>

        <Ticket>
          <div>
            <TicketHaveText>Você tem</TicketHaveText>
            <TicketValue>
              {formatters.toDecimal(user.points.actual)}
            </TicketValue>
            <TicketText>
              {' '}
              {user.points.actual === 1 ? 'pt' : 'pts'}
            </TicketText>
          </div>
        </Ticket>
      </HeaderElement>
      {children}
    </Fragment>
  )
}

Header.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    points: PropTypes.object,
    picture: PropTypes.string
  }).isRequired,
  children: PropTypes.node
}

export default Header
